import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const Header: React.FC = () => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="w-full flex justify-between items-center h-14">
        <div className="flex-none">
          <Link href="/" className="flex items-center">
            <Image 
              src="/logo_transparent.png" 
              alt="Mobile Mechanics Logo" 
              width={50}
              height={50}
              priority={true}
              className="w-[50px] h-[50px]"
            />
          </Link>
        </div>
        <div className="flex-1 flex justify-end">
          <nav>
            <ul className="flex space-x-8 mr-4">
              <li>
                <Link href="/about" className="text-gray-600 hover:text-blue-700 px-3 py-2 rounded-md text-base font-medium">
                  About
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-gray-600 hover:text-blue-700 px-3 py-2 rounded-md text-base font-medium">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header; 